function o(...e) {
  return (t) => {
    e.forEach((n) => {
      typeof n == "function" ? n(t) : n != null && (n.current = t);
    });
  };
}
export {
  o as mergeRefs
};
//# sourceMappingURL=index.es706.js.map
